// Public legal pages (no auth): privacy policy, terms of use, data-processing
// authorisation — the same CNDP texts users consent to in-app. Linked from the
// App Store / Google Play listings (a public privacy-policy URL is mandatory)
// and from the mobile app.
import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { LEGAL_DOCUMENTS } from '@/features/auth/components/ConsentModal';

const SLUG_TO_KEY: Record<string, string> = {
  privacy: 'PRIVACY_POLICY',
  'politique-de-confidentialite': 'PRIVACY_POLICY',
  terms: 'TERMS_OF_SERVICE',
  'conditions-utilisation': 'TERMS_OF_SERVICE',
  'data-processing': 'DATA_PROCESSING',
  'traitement-des-donnees': 'DATA_PROCESSING',
};

const NAV: { slug: string; label: string }[] = [
  { slug: 'privacy', label: 'Politique de confidentialité' },
  { slug: 'terms', label: "Conditions d'utilisation" },
  { slug: 'data-processing', label: 'Traitement des données' },
];

export const LegalPage: React.FC = () => {
  const { slug = 'privacy' } = useParams<{ slug: string }>();
  const key = SLUG_TO_KEY[slug] ?? 'PRIVACY_POLICY';
  const doc = LEGAL_DOCUMENTS[key];

  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#3F3A32]">
      <header className="border-b border-[#E3DCCF] bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4">
          <Link to="/login" className="text-xl font-extrabold tracking-widest text-[#0C2A33]">
            NEXEDU
          </Link>
          <nav className="flex flex-wrap gap-3 text-sm">
            {NAV.map((n) => (
              <Link
                key={n.slug}
                to={`/legal/${n.slug}`}
                className={
                  SLUG_TO_KEY[n.slug] === key
                    ? 'font-semibold text-[#0E7490] underline'
                    : 'text-[#7A7263] hover:text-[#0E7490]'
                }
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="mb-6 text-2xl font-bold text-[#0C2A33]">{doc.title}</h1>
        <pre className="whitespace-pre-wrap rounded-xl border border-[#E3DCCF] bg-white p-6 font-sans text-sm leading-6">
          {doc.content}
        </pre>
        <p className="mt-6 text-xs text-[#7A7263]">
          Pour toute question relative à vos données personnelles, contactez l'établissement auprès duquel vous êtes inscrit(e) ou NEXEDU via les coordonnées indiquées dans le document.
        </p>
      </main>
    </div>
  );
};

export default LegalPage;
